module.exports = __webpack_public_path__ + "media/images/preview/browser_header-fcb7840f36b46516f4a96b459f74428e.png";